<template>
    <div class="c-tr">
        <div class="c-td is-1">
            <span v-text="'Liczba wydanych worków'" class="typo-label" />
            <div class="handover-bags">
                <span
                    v-if="mark"
                    v-tooltip="mark.tooltip"
                    class="handover-fraction"
                    :class="{ 'is-mix': mark.mix }"
                    :style="mark.mix ? null : { background: mark.color }"
                />
                <span class="handover-bags__values">
                    <span v-text="bagsCount" />
                    <span v-text="`(${valueToCurrency(bags.value)})`" />
                </span>
            </div>
        </div>

        <div class="c-td is-2">
            <span v-text="'Data wydania'" class="typo-label" />
            <div v-text="issuedAt.date" />
            <p v-text="issuedAt.time" class="text-xs mb-0" />
        </div>

        <div class="c-td is-3">
            <span v-text="'Operator'" class="typo-label" />
            <span v-text="operatorName" />
        </div>

        <div class="c-td is-4">
            <span v-text="'Wydane przez'" class="typo-label" />
            <span class="handover-issuer">
                <img
                    v-if="issuedBy.deviceImage"
                    v-tooltip="issuedBy.deviceName"
                    :src="issuedBy.deviceImage"
                    alt=""
                />
                <a-icon
                    v-else
                    v-tooltip="issuedBy.deviceName"
                    icon="Info"
                    height="20"
                    width="20"
                    class="text-orange"
                />
                <span v-text="issuedBy.value" />
            </span>
        </div>

        <div class="c-td is-5">
            <the-btn
                text="Szczegóły"
                class="btn-outline-custom btn-sm"
                @click="openDetails"
            />
        </div>
    </div>
</template>

<script>
import { FRACTIONS } from '@/utils/constants/drs/fractions'
import handoverMixin from './handover.mixin'

export default {
    mixins: [handoverMixin],

    props: {
        handover: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        }
    },

    computed: {
        mark() {
            const fractions = this.handover.fractions || []

            if (!fractions.length) return null

            if (fractions.length > 1) {
                return { tooltip: 'Różne frakcje lub mix', mix: true }
            }

            const fraction = Object.values(FRACTIONS).find(item => item.id === fractions[0].id)

            if (!fraction) return null

            return {
                tooltip: fraction.name,
                color: fraction.color
            }
        }
    },

    methods: {
        openDetails() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/reports/HandoverDetails',
                args: { index: this.index }
            })
        }
    }
}
</script>

<style lang="scss">
.handover-bags,
.handover-issuer {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    min-width: 0;
}

.handover-bags__values {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.2;
}

.handover-issuer span {
    min-width: 0;
    overflow-wrap: break-word;
}

.handover-issuer img,
.handover-issuer .a-icon {
    width: 20px;
    height: 20px;
    flex: 0 0 auto;
}

.handover-fraction {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    flex: 0 0 auto;

    &.is-mix {
        background: linear-gradient(
            90deg,
            var(--color-warning) 50%,
            var(--color-info) 50%
        );
    }
}
</style>
